import PropTypes from "prop-types";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useIntl } from "react-intl";

import genericTranslations from "../../../utils/genericTranslations.js";

const messages = {
  sendNotification: {
    id: "modules.SoftwareNotification.components.PushNotificationConfirmationModal.sendNotification",
    description: "Send notification",
    defaultMessage: "Send notification",
  },
  sendNotificationConfirmation: {
    id: "modules.SoftwareNotification.components.PushNotificationConfirmationModal.sendNotificationConfirmation",
    description: "Send notification confirmation",
    defaultMessage:
      "Would you also like to send a push notification for this message?",
  },
  saveAndSend: {
    id: "modules.SoftwareNotification.components.PushNotificationConfirmationModal.saveAndSend",
    description: "Send and send push notification",
    defaultMessage: "Save & send push notification",
  },
};

const PushNotificationConfirmationModal = ({
  show,
  onClose,
  onSendNotification,
  onSendPushNotification,
}) => {
  const intl = useIntl();
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {intl.formatMessage(messages.sendNotification)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ padding: 15 }}>
          {intl.formatMessage(messages.sendNotificationConfirmation)}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          {intl.formatMessage(genericTranslations.close)}
        </Button>
        <Button variant="primary" onClick={onSendNotification}>
          {intl.formatMessage(genericTranslations.formSubmitLabel)}
        </Button>
        <Button variant="success" onClick={onSendPushNotification}>
          {intl.formatMessage(messages.saveAndSend)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

PushNotificationConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSendNotification: PropTypes.func.isRequired,
  title: PropTypes.string,
  body: PropTypes.string,
  closeButtonText: PropTypes.string,
  sendButtonText: PropTypes.string,
  sendWithPushButtonText: PropTypes.string,
};

export default PushNotificationConfirmationModal;
